import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { PaypalLinkedService } from 'app/model/linkedservice/paypal.linkedservice';
import { PaypalCopySource } from 'app/model/pipeline/copysource/paypal.copysource';
import { useEncryptedEndpointsRadioSwitch } from './linked-service-shared-fields';
import { format, stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const paypalMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(PaypalLinkedService).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Paypal_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-paypal'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    isFirstClass: true,
    supportDatasetV2: true,
    notShowInTypeSelection: true,
    category: ['ServicesApps'],
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(PaypalCopySource).name],
    controls: [
        {
            type: 'textbox',
            bind: 'host',
            label: stringResources.ModelName_Host,
            required: true,
            placeholder: stringResources.PayPal_Host_Placeholder,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            warningMessageCalculator: (value: string) =>
                stringIsNullOrEmpty(value) ? '' : stringResources.infoSentViaUrlWarning,
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'clientId',
            label: stringResources.ModelName_ClientId,
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'clientSecret',
            label: stringResources.ModelName_ClientSecret,
            child: {
                type: 'password',
                required: true,
                label: stringResources.ModelName_ClientSecret,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Paypal_DisplayText),
                stringResources.ModelName_ClientSecret)
        },
        useEncryptedEndpointsRadioSwitch
    ]
};
